/**
 * This is the shared module, for our commonly used shared components.
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import{
  FooterComponent,
  ScrollToTopComponent,
  ContactUsComponent,
  CrsDropDown,
  NotificationComponent,
  SpeedBumpDirective,
  InputMaskDirective,
  UserIdInputMaskDirective,
  PopupSitebookmarkComponent,
  PopupSiteDisclosureTncComponent
  } from './path';

import { PopupModalComponent } from './popup-modal/popup-modal.component';
import { PopupContentComponent } from './popup-content/popup-content.component';
import { PopupSiteLimitedAccessComponent } from './popup-content/site/popup-site-limited-access/popup-site-limited-access.component';
import { PopupSiteSpeedbumpComponent } from './popup-content/site/popup-site-speedbump/popup-site-speedbump.component';
import { PopupModalDirective } from './popup-modal.directive';
import { PopupSiteRedirectComponent } from './popup-content/site/popup-site-redirect/popup-site-redirect.component';
import { PopupSiteInfoComponent } from './popup-content/site/popup-site-info/popup-site-info.component';
import { ToolTipComponent } from './tooltip/tooltip.component';
import { ButtonSpinner } from './button-spinner.directive';
import { ScAutomaticCallDirective } from './sc-automatic-call-directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [
    FooterComponent,
    ContactUsComponent,
    CrsDropDown,
    ScrollToTopComponent,
    NotificationComponent,
    PopupModalComponent,
    PopupContentComponent,
    PopupSiteLimitedAccessComponent,
    PopupSiteSpeedbumpComponent,
    PopupSiteRedirectComponent,
    PopupSiteInfoComponent,
    ToolTipComponent,
    PopupSitebookmarkComponent,
    PopupSiteDisclosureTncComponent,
    //Directives
    SpeedBumpDirective,
    InputMaskDirective,
    UserIdInputMaskDirective,
    PopupModalDirective,
    ButtonSpinner,
    ScAutomaticCallDirective
  ],
  exports:[
    FooterComponent,
    ContactUsComponent,
    CrsDropDown,
    ScrollToTopComponent,
    NotificationComponent,
    PopupModalComponent,
    PopupContentComponent,
    PopupSiteLimitedAccessComponent,
    PopupSiteSpeedbumpComponent,
    PopupSiteRedirectComponent,
    PopupSiteInfoComponent,
    PopupSitebookmarkComponent,
    PopupSiteDisclosureTncComponent,
    ToolTipComponent,
    //Directives
    SpeedBumpDirective,
    InputMaskDirective,
    UserIdInputMaskDirective,
    PopupModalDirective,
    ButtonSpinner,
    ScAutomaticCallDirective
  ]
})
export class SharedModule { }
